import moment from 'moment'
import EncodingJapanese from 'encoding-japanese'

const DownloadMixin = {
  data() {
    return {
    }
  },
  methods: {
    /**
     * 文字コードをSJISに変換したCSVファイルのダウンロードを行います.
     * @param content { Object }
     * @param type_name
     */
    downloadSJISCsv (content, type_name) {
      let file_name = type_name + '_' + moment(new Date).format("YYYY-MM-DD_HH:mm:ss") + '.csv'
      let csv = new EncodingJapanese.stringToCode(content)
      csv = EncodingJapanese.convert( csv, 'SJIS');
      csv = new Uint8Array( csv );
      const blob = new Blob([csv], {type: 'text/csv'})
      this._downloadCsvBlob(blob, file_name, 'text/csv', false)
    },

    /**
     * CSVファイルのダウンロードを行います.
     * @param content { Blob }
     * @param type_name { String }
     */
    downloadCsv (content, type_name) {
      let file_name = type_name + '_' + moment(new Date).format("YYYY-MM-DD_HH:mm:ss") + '.csv'

      let csv = new EncodingJapanese.stringToCode(content)
      csv = EncodingJapanese.convert( csv, 'SJIS');
      csv = new Uint8Array(csv);
      const blob = new Blob([content], {type: 'text/csv'});
      this._downloadCsvBlob(blob, file_name, 'text/csv')
    },
    /**
     * CSVファイルのダウンロードを行います.
     * @param blob { Blob }
     * @param fileName { String }
     * @param mimeType { String }
     * @private
     */
    _downloadCsvBlob(blob, fileName, mimeType, enableBom = true) {
      let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]); // 変更 先頭の3バイト（BOM）を変数 bom へ代入
      if (!enableBom)
        bom = ''

      const url = URL.createObjectURL(new Blob([bom, blob], {type: mimeType}));
      const linkEl = document.createElement('a');
      linkEl.href = url;
      linkEl.setAttribute('download', fileName);
      document.body.appendChild(linkEl);
      linkEl.click();
      URL.revokeObjectURL(url);
      linkEl.parentNode.removeChild(linkEl);
    },
  }
}
export default DownloadMixin
